import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import themeUsersReducer from './themeUsers/reducers';
import { readMessageReducer } from './message/reducers';
import { readNotificationReducer } from './notification/reducers';
import authReducer from './authentication/reducers';
import ChangeLayoutMode from './themeLayout/reducers';
import { teamReducer } from './team/reducers';
// import { userReducer, userGroupReducer } from './users/reducers';
import { membersReducer, singleMemberReducer } from './users/members/reducers';
import { adminsReducer, singleAdminReducer } from './users/admins/reducers';
import { rolesReducer, singleRoleReducer, rolePermissionsReducer } from './users/roles/reducers'; 
import { listingsReducer, singleListingReducer } from './listingsManagement/listings/reducers';
import { itemCategoriesReducer, itemCategoryReducer } from './listingsManagement/itemCategories/reducers';
import { serviceCategoriesReducer, serviceCategoryReducer } from './listingsManagement/serviceCategories/reducers';
import { expertiseReducer, expertyReducer } from './listingsManagement/expertise/reducers';
import { itemConditionsReducer, itemConditionReducer } from './listingsManagement/itemConditions/reducers';
import { partnersReducer, partnerReducer } from './partnershipPrograms/reducers';
import { blogsReducer, blogReducer } from './blogs/reducers';
import { transactionsReducer, transactionReducer } from './transactions/reducers';
import { 
  organizationsReducer, 
  organizationReducer, 
  organizationSearchReducer 
} from './organizations/reducers';
import { userSearchReducer } from './userSearch/reducers';
import { donationListingsReducer, donationListingReducer } from './donationListings/reducers';
import { 
  volunteerListingsReducer, 
  volunteerListingReducer,
  orgVolunteerListingsReducer
} from './volunteerListings/reducers';

import { volunteerCategoriesReducer, volunteerCategoryReducer } from './volunteerCategories/reducers';
import { donationCategoriesReducer, donationCategoryReducer } from './donationCategories/reducers';

import { donationsReducer } from './donationAnalytics/reducers';
import { volunteerApplicationsReducer, volunteerApplicantsReducer } from './volunteerApplications/reducers';
import { volunteerApplicationFormsReducer, volunteerApplicationFormReducer } from './volunteerApplicationForm/reducers';

import { pricingPlansReducer } from './pricings/reducers';
import { plansReducer, planReducer } from './pricings/plans/reducers';
import { packagesReducer, packageReducer } from './pricings/packages/reducers';
import { packageFeaturesReducer, packageFeatureReducer } from './pricings/packageFeatures/reducers';

import { contactFormsReducer, contactFormReducer } from './contactUs/reducers';
import { listingsReportsReducer, listingReportReducer } from './listingsReports/reducers';

import { sellersReducer } from './sellers/reducers';
import { headerSearchReducer } from './headerSearch/reducers';
import orderReducer from './orders/reducers';
import galleryReducer from './gallary/reducers';
import chartContentReducer from './chartContent/reducers';
import { emailReducer, SingleEmailReducer } from './email/reducers';
import { productReducer, SingleProductReducer } from './product/reducers';
import { chatReducer, SingleChatReducer, groupChatReducer, SingleChatGroupReducer } from './chat/reducers';
import { projectReducer, SingleProjectReducer } from './project/reducers';
import cartData from './cart/reducers';
import Todo from './todo/reducers';
import Note from './note/reducers';
import Task from './task/reducers';
import Contact from './contact/reducers';
import Profile from './profile/reducers';
import Calender from './calendar/reducers';
import FileManager from './fileManager/reducers';
import { axiosCrudReducer, axiosSingleCrudReducer } from './crud/axios/reducers';

import { fsCrudReducer, fsSingleCrudReducer } from './firebase/firestore/reducers';
import firebaseAuth from './firebase/auth/reducers';

const rootReducers = combineReducers({
  fb: firebaseReducer,
  fs: firestoreReducer,
  themeUsers: themeUsersReducer,
  headerSearchData: headerSearchReducer,
  message: readMessageReducer,
  notification: readNotificationReducer,
  orders: orderReducer,
  sellers: sellersReducer,
  // Users
  members: membersReducer,
  member: singleMemberReducer,
  admins: adminsReducer,
  admin: singleAdminReducer,
  roles: rolesReducer,
  role: singleRoleReducer,
  rolePermissions: rolePermissionsReducer,

  // Listings Management
  listings: listingsReducer,
  listing: singleListingReducer,
  itemCategories: itemCategoriesReducer,
  serviceCategories: serviceCategoriesReducer,
  itemConditions: itemConditionsReducer,
  expertise: expertiseReducer,  
  itemCategory: itemCategoryReducer,
  itemCondition: itemConditionReducer,
  serviceCategory: serviceCategoryReducer,
  experty: expertyReducer,
  // Partners
  partners: partnersReducer,
  partner: partnerReducer,

  // blogs
  blogs: blogsReducer,
  blog: blogReducer,
  
  // transactions
  transactions: transactionsReducer,
  transaction: transactionReducer,

  // organizations
  organizations: organizationsReducer,
  organization: organizationReducer,
  organizationsList: organizationSearchReducer,
  // user search
  userSearchData: userSearchReducer,
  
  // donation listings
  donationListings: donationListingsReducer,
  donationListing: donationListingReducer,

  // volunteer listings
  volunteerListings: volunteerListingsReducer,
  volunteerListing: volunteerListingReducer,
  orgVolunteerListings: orgVolunteerListingsReducer,

  donations: donationsReducer,
  volunteerApplications: volunteerApplicationsReducer,
  volunteerApplicants: volunteerApplicantsReducer,

  volunteerApplicationForms: volunteerApplicationFormsReducer,
  volunteerApplicationForm: volunteerApplicationFormReducer,

  volunteerCategories: volunteerCategoriesReducer,
  volunteerCategory: volunteerCategoryReducer,

  donationCategories: donationCategoriesReducer,  
  donationCategory: donationCategoryReducer,

  pricingPlans: pricingPlansReducer,  

  plans: plansReducer,  
  plan: planReducer,

  packages: packagesReducer,  
  package: packageReducer,

  packageFeatures: packageFeaturesReducer,  
  packageFeature: packageFeatureReducer,

  contactQueries: contactFormsReducer,  
  contactQuery: contactFormReducer,
  
  listingsReports: listingsReportsReducer,  
  listingReport: listingReportReducer,

  team: teamReducer,
  auth: authReducer,
  gallery: galleryReducer,
  email: emailReducer,
  emailSingle: SingleEmailReducer,
  products: productReducer,
  product: SingleProductReducer,
  chatSingle: SingleChatReducer,
  chatSingleGroup: SingleChatGroupReducer,
  chat: chatReducer,
  groupChat: groupChatReducer,
  projects: projectReducer,
  project: SingleProjectReducer,
  ChangeLayoutMode,
  chartContent: chartContentReducer,
  crud: fsCrudReducer,
  singleCrud: fsSingleCrudReducer,
  cart: cartData,
  Todo,
  Note,
  Task,
  Contact,
  Profile,
  Calender,
  firebaseAuth,
  FileManager,
  AxiosCrud: axiosCrudReducer,
  SingleAxiosCrud: axiosSingleCrudReducer,
});

export default rootReducers;
